import { OfferMerchandiseTypeEnum } from './enums/offer-merchandise-type.enum';

export class MerchandiseType {
  code!: string;
  labelKey!: string;
  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export const LIST_MARCHANDISE_TYPE: { [key: string]: MerchandiseType } = {
  CONDITIONED: new MerchandiseType({ code: OfferMerchandiseTypeEnum.CONDITIONED, labelKey: '' }),
  UNCONDITIONED: new MerchandiseType({ code: OfferMerchandiseTypeEnum.UNCONDITIONED, labelKey: '' }),
  QUOTATION: new MerchandiseType({ code: OfferMerchandiseTypeEnum.QUOTATION, labelKey: '' }),
};
